import $ from 'jquery';
import * as FIUser from './FIUser.js';

window._fiSponsor = window._fiSponsor || new FISponsor();

function FISponsor(options) {

	var self = this;

	Object.defineProperty(this, "sponsors", FIUser._propertyDefaultsData({ value : []}));

	// sync data
	function syncData(i, data) {
		// Initialize the object
		var defaults = $.extend({
			id : '',
			name : '',
			fi_rtn : [],
			min_age : 18,
			review_period : '',
			type : '',
			state : '',
			postalcode : '',
			maxcontribution : '',
			invitereward : '',
			link_via_api : '',
			userinvites : '',
			referral_promo_value : '',
			referral_promo_limit : '',
			referral_promo_start_date : '',
			referral_promo_end_date : '',
			promotions : {},
			buildskills_enabled : '',
			provider_code : '',
			subdomain :  '',
			zips : '',
			sponsor_mesage : '',
			codeprefix : '',
			colors : '',
			hoist_logo : '',
			programid : '',
			rewards_penalty_free : '',
			rewards_available_before_goal_complete : '',
			ext_account_verification_type : '',
			total_saved : '0',
			averages : {},
			goal_totals : {},
			goal_maximums : {},
			zipData : {},
			aoZipData : {},
			fiData : {},
			growthData : {},
			rangeData : {},
			depositData : {},
			completedgoalsData : {},
			buildSkillsData : {},
      what_others: [],
			logo_white_url : '',
			strategic_goals : {},
			recommendations : {}
		}, data);

		if(defaults.total_saved === null) defaults.total_saved = '0';

		self.sponsors[i] = Object.create(null); //INITIALIZE eMPTY OBJECT

		self.sponsors[i].id = defaults.id;
		self.sponsors[i].name = defaults.name;
		self.sponsors[i].fi_rtn = defaults.fi_rtn.split(',');
		self.sponsors[i].min_age = defaults.min_age;
		self.sponsors[i].review_period  = defaults.review_period;
		self.sponsors[i].type = defaults.type;
		self.sponsors[i].state = defaults.state;
		self.sponsors[i].postalcode = defaults.postalcode;
		self.sponsors[i].maxcontribution = defaults.maxcontribution;
		self.sponsors[i].invitereward = defaults.invitereward;
		self.sponsors[i].link_via_api = defaults.link_via_api;
		self.sponsors[i].userinvites = defaults.userinvites;
		self.sponsors[i].referral_promo_value = defaults.referral_promo_value;
		self.sponsors[i].referral_promo_limit = defaults.referral_promo_limit;
		self.sponsors[i].referral_promo_start_date = defaults.referral_promo_start_date;
		self.sponsors[i].referral_promo_end_date = defaults.referral_promo_end_date;
		self.sponsors[i].promotions = (Object.keys(defaults.promotions).length || typeof self.sponsors[i].promotions === 'undefined') ? defaults.promotions : self.sponsors[i].promotions;
		self.sponsors[i].buildskills_enabled = defaults.buildskills_enabled;
		self.sponsors[i].provider_code = defaults.provider_code;
		self.sponsors[i].subdomain = defaults.subdomain;
		self.sponsors[i].zips = defaults.zips;
		self.sponsors[i].sponsor_mesage = defaults.sponsor_mesage;
		self.sponsors[i].codeprefix = defaults.codeprefix;
		self.sponsors[i].colors = defaults.colors;
		self.sponsors[i].hoist_logo = defaults.hoist_logo;
		self.sponsors[i].programid = defaults.programid;
		self.sponsors[i].rewards_penalty_free = defaults.rewards_penalty_free;
		self.sponsors[i].rewards_available_before_goal_complete = defaults.rewards_available_before_goal_complete;
		self.sponsors[i].ext_account_verification_type = defaults.ext_account_verification_type;
		self.sponsors[i].total_saved = ((defaults.total_saved && defaults.total_saved.length) || typeof self.sponsors[i].total_saved === 'undefined') ? defaults.total_saved : self.sponsors[i].total_saved;
		self.sponsors[i].averages = ((defaults.averages && defaults.averages.length) || typeof self.sponsors[i].averages === 'undefined') ? defaults.averages : self.sponsors[i].averages;
		self.sponsors[i].goal_totals = ((defaults.goal_totals && defaults.goal_totals.length) || typeof self.sponsors[i].goal_totals === 'undefined') ? defaults.goal_totals : self.sponsors[i].goal_totals;
		self.sponsors[i].goal_maximums = ((defaults.goal_maximums && defaults.goal_maximums.length) || typeof self.sponsors[i].goal_maximums === 'undefined') ? defaults.goal_maximums : self.sponsors[i].goal_maximums;
		self.sponsors[i].zipData = (Object.keys(defaults.zipData).length || typeof self.sponsors[i].zipData === 'undefined') ? defaults.zipData : self.sponsors[i].zipData;
		self.sponsors[i].aoZipData = (Object.keys(defaults.aoZipData).length || typeof self.sponsors[i].aoZipData === 'undefined') ? defaults.aoZipData : self.sponsors[i].aoZipData;
		self.sponsors[i].fiData = (Object.keys(defaults.fiData).length || typeof self.sponsors[i].fiData === 'undefined') ? defaults.fiData : self.sponsors[i].fiData;
		self.sponsors[i].growthData = (Object.keys(defaults.growthData).length || typeof self.sponsors[i].growthData === 'undefined') ? defaults.growthData : self.sponsors[i].growthData;
		self.sponsors[i].rangeData = (Object.keys(defaults.rangeData).length || typeof self.sponsors[i].rangeData === 'undefined') ? defaults.rangeData : self.sponsors[i].rangeData;
		self.sponsors[i].depositData = (Object.keys(defaults.depositData).length || typeof self.sponsors[i].depositData === 'undefined') ? defaults.depositData : self.sponsors[i].depositData;
		self.sponsors[i].completedgoalsData = (Object.keys(defaults.completedgoalsData).length || typeof self.sponsors[i].completedgoalsData === 'undefined') ? defaults.completedgoalsData : self.sponsors[i].completedgoalsData;
		self.sponsors[i].buildSkillsData = (Object.keys(defaults.buildSkillsData).length || typeof self.sponsors[i].buildSkillsData === 'undefined') ? defaults.buildSkillsData : self.sponsors[i].buildSkillsData;
		self.sponsors[i].what_others = (Object.keys(defaults.what_others).length || typeof self.sponsors[i].what_others === 'undefined') ? defaults.what_others : self.sponsors[i].what_others;
    self.sponsors[i].logo_white_url = (self.sponsors[i].id) ? "https://s3-us-west-2.amazonaws.com/plinqit-sp/" + self.sponsors[i].id.slice(0,8) + '-white' : '';
		self.sponsors[i].strategic_goals = (Object.keys(defaults.strategic_goals).length || typeof self.sponsors[i].strategic_goals === 'undefined') ? defaults.strategic_goals : self.sponsors[i].strategic_goals;
		self.sponsors[i].recommendations = (Object.keys(defaults.recommendations).length || typeof self.sponsors[i].recommendations === 'undefined') ? defaults.recommendations : self.sponsors[i].recommendations;

	}

	//Compare routing numbers
	this.isSponsor = function(rtns) {
		var rtnArr = rtns.split(',');

		for(var rKey in rtnArr) {
			var rtn = rtnArr[rKey];

			if(this.sponsors[0].fi_rtn.indexOf(rtn) > -1) {
				return true;
			}
		}

		return false;
	}

	this.uriEncodedName = function() {
		if(!this.sponsors || !this.sponsors[0] || !this.sponsors[0].name) return 'Unnamed';
		return encodeURI(this.sponsors[0].name.replace(/ /g, ''));
	}

	//Sponsor getter
	this.GET = function(cb, sponsorid, i) {
		
		if(sponsorid.length === 0) {
			cb();
			return;
		}

		var headers = {
			'User-Token' : window._fiUser.token,
			'Client-Portal' : true
		};

		var me = this;
		const getID = sponsorid || window._fiUser.sponsorid;

		$.ajax({
			url: window.app.apiurl + "FISponsors/" + getID,
			type : 'GET',
			headers : headers,
			dataType : 'json',
			success : function (response) {
				
				if(response.code === 200) {
					syncData(i, response.data);
					me.saveSessionInfo();
				}
			},
			error : function(response) {
				////console.log(response); //For Debug! Remove
			},
			complete : function(response) {
				if(cb) cb(response.responseJSON);
			}

		});
	};

	this.GET_ALL = function(cb) {

		var iteration = -1;
		var spon = this;

		var callback = function(r) {
			iteration += 1;
			//console.log("Iteration: " + iteration);
			//console.log(window._fiUser.linked_ids.length);

			if(iteration < window._fiUser.linked_ids.length) {
				spon.GET(callback, window._fiUser.linked_ids[iteration], iteration + 1);
				return;
			}

			cb(window._fiSponsor);
		};

		this.GET(callback, window._fiUser.sponsorid, iteration + 1);
	}

	this.GET_STRATEGIC_GOALS = function(cb) {
		var headers = {
			'User-Token' : window._fiUser.token,
			'Client-Portal' : true
		};

		var obj = this;

		$.ajax({
			url: window.app.apiurl + "FIStrategicGoals/" + this.sponsors[0].id,
			type: 'GET',
			headers: headers,
			dataType: 'json',
			success : function (response) {
				if(response.code === 200) {
					obj.sponsors[0].strategic_goals = response.data.strategic_goals;
					obj.saveSessionInfo();
				}
			},
			error : function (response) {
				obj.sponsors[0].strategic_goals = response;
				obj.saveSessionInfo();
			},
			complete : function (response) {
				cb(response.responseJSON);
			}
		});
	}

	this.UPDATE_STRATEGIC_GOALS = function(cb, plan_file = false) {
		var headers = {
			'User-Token' : window._fiUser.token,
			'Client-Portal' : true
		};

		var obj = this;

		var data = this.sponsors[0].strategic_goals;

		data.user_name = window._fiUser.firstname + ' ' + window._fiUser.lastname;

		if(plan_file && typeof plan_file !== 'undefined') {
			data = new FormData();
			data.append('marketing_plan', plan_file);

			for(var sKey in this.sponsors[0].strategic_goals) {
				data.append(sKey, this.sponsors[0].strategic_goals[sKey]);
			}

			data.append('user_name', window._fiUser.firstname + ' ' + window._fiUser.lastname);

			//ajaxRequest['processData'] = false;
  			//ajaxRequest['contentType'] = false;
		}
		else {
			data = JSON.stringify(data);
		}

		var ajaxRequest = {
			url: window.app.apiurl + "FIStrategicGoals/" + this.sponsors[0].id,
			type: 'POST',
			headers: headers,
			data: data,
			dataType: 'json',
			processData: false,
			contentType: false,
			success : function (response) {
				if(response.code === 200) {
					obj.sponsors[0].strategic_goals = response.data.strategic_goals;
					obj.saveSessionInfo();
				}
			},
			error : function (response) {
				obj.sponsors[0].strategic_goals = response;
				obj.saveSessionInfo();
			},
			complete : function (response) {
				cb(response.responseJSON);
			}
		};

		$.ajax(ajaxRequest);
	}

	this.GET_RECOMMENDATIONS = function(cb) {
		var headers = {
			'User-Token' : window._fiUser.token,
			'Client-Portal' : true
		};

		var obj = this;

		$.ajax({
			url: window.app.apiurl + "FISponsors/" + this.sponsors[0].id + "/recommends/",
			data: {'type' : 'all'},
			type: 'GET',
			headers: headers,
			dataType: 'json',
			success : function (response) {
				if(response.code === 200) {
					obj.sponsors[0].recommendations = response.data;
					obj.saveSessionInfo();
				}
			},
			error : function (response) {
				obj.sponsors[0].recommendations = response;
				obj.saveSessionInfo();
			},
			complete : function (response) {
				cb(response.responseJSON);
			}
		});
	}

	this.selectSponsor = function(id) {

		this.sponsors = this.sponsors.sort(function(x,y){ return x.id === id ? -1 : y.id === id ? 1 : 0; });
		this.saveSessionInfo();
		////console.log("SORTED");
		////console.log(this.sponsors);

		window.location.reload();
	}

	// load session token
	this.loadSessionInfo = function() {
		var sessionData = JSON.parse(sessionStorage.getItem('_fiSponsor'));;
		////console.log(sessionData);
		if(!FIUser.isEmpty(sessionData)) {
			this.sponsors = sessionData;
			return true;
		}
		else
		{
			var sessionStData = FIUser._getCookie("ht_sponsor_pqd")
			if(!FIUser.isEmpty(sessionStData))
			{
				this.sponsors = sessionStData.sponsors;
				return true;
			}
		}
		return false;
	};

	// save session token
	this.saveSessionInfo = function() {
		FIUser._setCookie("ht_sponsor_pqd", { sponsors : this.sponsors
		}, 7, undefined, undefined, true);
		
		sessionStorage.setItem('_fiSponsor', JSON.stringify(this.sponsors));
	};

	this.deleteSessionInfo = function() {
		////console.log('***Deleting session info!');
		this.sponsors = [];
		
		sessionStorage.removeItem('_fiSponsor');
		FIUser._deleteCookie("ht_sponsor_pqd");
	};

	function isDataLoaded(data) {
		
		return (data && typeof data !== 'undefined' && Object.keys(data).length && data.detail === "Report generated" && (new Date()).getTime() - data.time < 250000);

	}

	this.getUserAgeData = function(cb) {
		this.loadSessionInfo();
		if(isDataLoaded(this.sponsors[0].rangeData)) {
			////console.log(this.sponsors[0].name + " Data returned");
			cb(this.sponsors[0].rangeData);
			return;
		}
		var data = {
			type : 'agerange',
			sponsorid : window._fiUser.sponsorid
		};

		var obj = this;

		$.ajax({
			url: window.app.apiurl + 'FISponsors/' + this.sponsors[0].id + '/reports',
			headers: {
				"User-Token" : window._fiUser.token,
				"Client-Portal" : true
			},
			contentType: false,
			data: data,
			type: 'GET',
			dataType: 'json',
			success: function(response) {
				obj.sponsors[0].rangeData = response;
				obj.sponsors[0].rangeData.time = (new Date()).getTime();
				obj.saveSessionInfo();
				cb(response);
				
			},
			error: function(response) {
				obj.sponsors[0].rangeData = response;
				cb(response);
			}
		});
	};

	this.getZipData = function(cb, activeOnly) {
		this.loadSessionInfo();
		//console.log('Looking for active only: ' + activeOnly);
		if(!activeOnly && isDataLoaded(this.sponsors[0].zipData)) {
			
			cb(this.sponsors[0].zipData);
			return;
		}
		else if(activeOnly && isDataLoaded(this.sponsors[0].aoZipData)) {

			cb(this.sponsors[0].aoZipData);
			return;
		}

		var data = {
			type : 'usersbyzip',
			sponsorid : window._fiUser.sponsorid
		};

		if(activeOnly) {
			data.active = true;
		}

		var obj = this;

		$.ajax({
			url: window.app.apiurl + 'FISponsors/' + this.sponsors[0].id + '/reports',
			headers: {
				"User-Token" : window._fiUser.token,
				"Client-Portal" : true
			},
			contentType: false,
			data: data,
			type: 'GET',
			dataType: 'json',
			success: function(response) {
				if(activeOnly) {
					obj.sponsors[0].aoZipData = response;
					obj.sponsors[0].aoZipData.time = (new Date()).getTime();
				}
				else {
					obj.sponsors[0].zipData = response;
					obj.sponsors[0].zipData.time = (new Date()).getTime();
				}
				obj.saveSessionInfo();
				cb(response);
			},
			error: function(response) {
				if(activeOnly) obj.sponsors[0].aoZipData = response;
				else obj.sponsors[0].zipData = response;
				cb(response);
			}
		});
	};

	this.getFIUserData = function(cb) {
		this.loadSessionInfo();
		if(isDataLoaded(this.sponsors[0].fiData)) {
			
			cb(this.sponsors[0].fiData);
			return;
		}

		var data = {
			type : 'usersperfi',
			sponsorid : window._fiUser.sponsorid
		};

		var obj = this;

		$.ajax({
			url: window.app.apiurl + 'FISponsors/' + this.sponsors[0].id + '/reports',
			headers: {
				"User-Token" : window._fiUser.token,
				"Client-Portal" : true
			},
			contentType: false,
			data: data,
			type: 'GET',
			dataType: 'json',
			success: function(response) {
				obj.sponsors[0].fiData = response;
				obj.sponsors[0].fiData.time = (new Date()).getTime();
				obj.saveSessionInfo();
				cb(response);
			},
			error: function(response) {
				obj.sponsors[0].fiData = response;
				cb(response);
			}
		});
	}

	this.getUserGrowthData = function(cb) {
		this.loadSessionInfo();
		if(isDataLoaded(this.sponsors[0].growthData)) {
			
			cb(this.sponsors[0].growthData);
			return;
		}

		var data = {
			type : 'usergrowth',
			sponsorid : window._fiUser.sponsorid
		};
		var obj = this;

		$.ajax({
			url: window.app.apiurl + 'FISponsors/' + this.sponsors[0].id + '/reports',
			headers: {
				"User-Token" : window._fiUser.token,
				"Client-Portal" : true
			},
			contentType: false,
			data: data,
			type: 'GET',
			dataType: 'json',
			success: function(response) {
				obj.sponsors[0].growthData = response;
				obj.sponsors[0].growthData.time = (new Date()).getTime();
				obj.saveSessionInfo();
				cb(response);
			},
			error: function(response) {
				obj.sponsors[0].growthData = response;
				cb(response);
			}
		});
	};

	this.getDeposits = function(cb) {
		this.loadSessionInfo();

		if(isDataLoaded(this.sponsors[0].depositData)) {

			cb(this.sponsors[0].depositData);
			return;
		}

		var data = {
			type : 'depositgrowth',
			sponsorid : window._fiUser.sponsorid
		};

		var obj = this;

		$.ajax({
			url: window.app.apiurl + 'FISponsors/' + this.sponsors[0].id + '/reports',
			headers : {
				"User-Token" : window._fiUser.token,
				"Client-Portal" : true
			},
			contentType : false,
			data: data,
			type: 'GET',
			dataType: 'json',
			success: function(response) {
				obj.sponsors[0].depositData = response;
				obj.sponsors[0].depositData.time = (new Date()).getTime();
				obj.saveSessionInfo();
				cb(response);
				
			},
			error: function(response) {
				obj.sponsors[0].depositData = response;
				cb(response);
			}
		});
	};

	this.getCompletedGoals = function(cb) {
		this.loadSessionInfo();

		if(isDataLoaded(this.sponsors[0].completedgoalsData)) {

			cb(this.sponsors[0].completedgoalsData);
			return;
		}

		var data = {
			type : 'completedgoals',
			sponsorid : window._fiUser.sponsorid
		};

		var obj = this;

		$.ajax({
			url: window.app.apiurl + 'FISponsors/' + this.sponsors[0].id + '/reports',
			headers : {
				"User-Token" : window._fiUser.token,
				"Client-Portal" : true
			},
			contentType : false,
			data: data,
			type: 'GET',
			dataType: 'json',
			success: function(response) {
				obj.sponsors[0].completedgoalsData = response;
				obj.sponsors[0].completedgoalsData.time = (new Date()).getTime();
				obj.saveSessionInfo();
				cb(response);
				
			},
			error: function(response) {
				obj.sponsors[0].completedgoalsData = response;
				cb(response);
			}
		});
	};

	this.getGoalsAverages = function(cb) {
		this.loadSessionInfo();
		if(isDataLoaded(this.sponsors[0].averages)) {
			cb(this.sponsors[0].averages);
			return;
		}

		var data = {
			type : 'averagegoal',
			sponsorid : window._fiUser.sponsorid
		};
		var obj = this;

		$.ajax({
			url: window.app.apiurl + 'FISponsors/' + this.sponsors[0].id + '/reports',
			headers: {
				"User-Token" : window._fiUser.token,
				"Client-Portal" : true
			},
			contentType: false,
			data: data,
			type: 'GET',
			dataType: 'json',
			success: function(response) {
				obj.sponsors[0].averages = response;
				obj.sponsors[0].averages.time = (new Date()).getTime();
				obj.saveSessionInfo();
				cb(response);
				
			},
			error: function(response) {
				obj.sponsors[0].averages = response;
				cb(response);
			}
		});
	};

	this.getGoalsTotals = function(cb) {

		if(this && this.loadSessionInfo) this.loadSessionInfo();
		if(isDataLoaded(this.sponsors[0].goal_totals)) {
			cb(this.sponsors[0].goal_totals);
			return;
		}

		var data = {
			type : 'totalgoal',
			sponsorid : window._fiUser.sponsorid
		};
		var obj = this;

		$.ajax({
			url: window.app.apiurl + 'FISponsors/' + this.sponsors[0].id + '/reports',
			headers: {
				"User-Token" : window._fiUser.token,
				"Client-Portal" : true
			},
			contentType: false,
			data: data,
			type: 'GET',
			dataType: 'json',
			success: function(response) {
				obj.sponsors[0].goal_totals = response;
				obj.sponsors[0].goal_totals.time = (new Date()).getTime();
				obj.saveSessionInfo();
				cb(response);
				
			},
			error: function(response) {
				obj.sponsors[0].goal_totals = response;
				cb(response);
			}
		});
	};

	this.getGoalsMaximums = function(cb) {

		if(this && this.loadSessionInfo) this.loadSessionInfo();
		if(isDataLoaded(this.sponsors[0].goal_maximums)) {
			cb(this.sponsors[0].goal_maximums);
			return;
		}

		var data = {
			type : 'maxgoal',
			sponsorid : window._fiUser.sponsorid
		};
		var obj = this;

		$.ajax({
			url: window.app.apiurl + 'FISponsors/' + this.sponsors[0].id + '/reports',
			headers: {
				"User-Token" : window._fiUser.token,
				"Client-Portal" : true
			},
			contentType: false,
			data: data,
			type: 'GET',
			dataType: 'json',
			success: function(response) {
				obj.sponsors[0].goal_maximums = response;
				obj.sponsors[0].goal_maximums.time = (new Date()).getTime();
				obj.saveSessionInfo();
				cb(response);
				
			},
			error: function(response) {
				obj.sponsors[0].goal_maximums = response;
				cb(response);
			}
		});
	};

  this.getWhatOthers = function(cb, page, pagesize) {

    if(this && this.loadSessionInfo) this.loadSessionInfo();
    if(isDataLoaded(this.sponsors[0].what_others[page])) {
      cb(this.sponsors[0].what_others[page]);
      return;
    }

    var data = {
      type : 'others',
      sponsorid : window._fiUser.sponsorid,
      page : page,
      count: pagesize
    };
    var obj = this;

    $.ajax({
      url: window.app.apiurl + 'FISponsors/' + this.sponsors[0].id + '/reports',
      headers: {
        "User-Token" : window._fiUser.token,
        "Client-Portal" : true
      },
      contentType: false,
      data: data,
      type: 'GET',
      dataType: 'json',
      success: function(response) {
        obj.sponsors[0].what_others[page] = response;
        obj.sponsors[0].what_others[page].time = (new Date()).getTime();
        obj.saveSessionInfo();
        cb(response);
        
      },
      error: function(response) {
        obj.sponsors[0].what_others[page] = response;
        cb(response);
      }
    });
  };

	this.getBuildSkillsData = function(cb) {
		this.loadSessionInfo();
		if(isDataLoaded(this.sponsors[0].buildSkillsData)) {
			cb(this.sponsors[0].buildSkillsData);
			return;
		}

		var data = {
			type : 'buildskills',
			sponsorid : window._fiUser.sponsorid
		};
		var obj = this;

		$.ajax({
			url: window.app.apiurl + 'FISponsors/' + this.sponsors[0].id + '/reports',
			headers: {
				"User-Token" : window._fiUser.token,
				"Client-Portal" : true
			},
			contentType: false,
			data: data,
			type: 'GET',
			dataType: 'json',
			success: function(response) {
				obj.sponsors[0].buildSkillsData = response;
				obj.sponsors[0].buildSkillsData.time = (new Date()).getTime();
				obj.saveSessionInfo();
				cb(response);
			},
			error: function(response) {
				obj.sponsors[0].buildSkillsData = response;
				cb(response);
			}
		});
	}

}
